import { Row, Col, PageHeader } from 'antd';

export default function MainPageHeader() {
    return (
        <Row >
            <Col >
                <PageHeader
                    onBack={() => window.history.back()}
                    title="Επιστροφή"
                />
            </Col>
        </Row>
    )
}
